import { API_PATH_INTERNAL } from '@/lib/constants'
import apiService from '@/lib/services/apiService'
import { PaginationFilters } from '@/types/api'
import { ReviewCollection, ReviewItem } from '@/types/responses/review'

class ReviewService {
  async getReviewsForCompany(
    companyId: number,
    filters: PaginationFilters,
  ): Promise<ReviewCollection> {
    const params = { 'company.id': companyId, ...filters }
    const response = await apiService.get<ReviewCollection>(
      `${API_PATH_INTERNAL}/reviews`,
      {
        params,
      },
    )

    return response.data
  }

  async getReview(reviewId: number): Promise<ReviewItem> {
    const response = await apiService.get<ReviewItem>(
      `${API_PATH_INTERNAL}/reviews/${reviewId}`,
    )

    return response.data
  }
}

const reviewService = new ReviewService()

export default reviewService
